export class CommandAction {
  public readonly name: string;
  public readonly undoAble: boolean;

  private readonly _action: VoidFunction;
  private readonly _undo?: VoidFunction;
  private readonly _clear?: VoidFunction;

  constructor(name: string, action: VoidFunction, undo?: VoidFunction, clear?: VoidFunction) {
    if (!name?.trim()) {
      throw new Error("Name passed is either not string or is empty!");
    }

    this.name = name;
    this._action = action;
    this._undo = undo;
    this._clear = clear;
    this.undoAble = !!undo;
  }

  public execute() {
    this._action();
  }

  public undo() {
    this._undo?.();
  }

  public clear() {
    this._clear?.();
  }
}

export default CommandAction;
